import React, { Fragment, useEffect } from "react";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import { useHistory } from "react-router";

const Marketplace = () => {
  const history = useHistory();
  const url = history.location.pathname;
  console.log("HISTORY", history.location.pathname);
  useEffect(() => {
    if (url == "/marketplace") {
      history.push("/marketplace/block-libraries");
    }
  });
  return <Fragment></Fragment>;
};

export default Marketplace;
